export default (value) => {
    // eslint-disable-next-line no-useless-escape
    return value.replace(/[\u00A0-\u9999]/g, (char) => {
        return `&#${char.charCodeAt(0)};`
    })
}
